import { Icon } from "@chakra-ui/react";
import React from "react";
import {
  getTwoToneChakraColors,
  TwoToneIconProps,
} from "./getTwoToneChakraColors";

export function SiLifo({
  colorScheme = "primary",
  primaryShade = 600,
  secondaryShade = 200,
  ...props
}: TwoToneIconProps) {
  const { primaryColor, secondaryColor } = getTwoToneChakraColors({
    colorScheme,
    primaryShade,
    secondaryShade,
  });

  return (
    <Icon viewBox="0 0 32 32" fill="none" {...props}>
      <line
        x1="11.0998"
        y1="15.9998"
        x2="26.0998"
        y2="15.9998"
        stroke={secondaryColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M11.8996 22.8999L5.83489 16.9277C5.31836 16.4191 5.31202 15.588 5.82073 15.0715L11.8996 8.8999"
        stroke={primaryColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Icon>
  );
}
